import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './i18n/config';

const rootElement = document.getElementById('root');

const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Production HTML is prerendered; Vite development starts with an empty root.
if (rootElement.childElementCount > 0) hydrateRoot(rootElement, app);
else createRoot(rootElement).render(app);
